import styled from "styled-components";
import { CreateDropdown } from "../CreateDropdown/CreateDropdown";
import { CreateButton } from "../Header.styled";

export const MobileMenuWrapper = styled.div`
  width: 100%;
  background: rgba(46, 46, 52, 0.69);
  min-height: ${(props) => (props.openMenu ? "100vh" : "0")};
  height: ${(props) => (props.openMenu ? "100%" : "0")};
  z-index: 49px;
  transition: 0.2s;
  overflow: hidden;
`;

export const MobileMenuBody = styled.div`
  background: ${(props) => props.theme.body};
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > a {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    margin: 15px 0;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
  }
`;

export const CreateButtonMobile = styled(CreateButton)`
  @media (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`;
